"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startListening = exports.startDocumentsListener = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var documents_1 = require("./documents");
Object.defineProperty(exports, "startDocumentsListener", { enumerable: true, get: function () { return documents_1.startDocumentsListeners; } });
const listenerMiddleware = (0, toolkit_1.createListenerMiddleware)();
exports.startListening = listenerMiddleware.startListening;
exports.default = listenerMiddleware.middleware;
